import React, { useState, useEffect } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import Button from 'react-bootstrap/Button';
import { IconDeviceFloppy, IconSquareX } from '@tabler/icons-react';
import { useParams } from 'react-router';
import SelectProfile from 'react-select';
import { validationAccess } from "../../../helpers/validationAccess"
import {
  getModule, setHrefWithSlugHook, getSlug
} from "../../../../src/config/routes/guards/slug";
import { useLocation } from 'react-router';

const EditRiskManagementMonitoringComp = (props) => {
  // console.log(props);
  const routeParams = useParams();

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [listRiskProfile, setlistRiskProfile] = useState(
    props?.editRiskManagementMonitoring?.listRiskProfile
  );
  const [idRiskProfile, setidRiskProfile] = useState({
    value: props?.editRiskManagementMonitoring?.risk_profile?.id,
    label: props?.editRiskManagementMonitoring?.risk_profile?.rootCause,
  });

  const [notYetHandled, setnotYetHandled] = useState(
    props?.editRiskManagementMonitoring?.notYetHandled
  );
  const [improvementIdea, setimprovementIdea] = useState(
    props?.editRiskManagementMonitoring?.improvementIdea
  );
  const [monitoringTime, setmonitoringTime] = useState(
    props?.editRiskManagementMonitoring?.monitoringTime
  );
  const [monitoringCycle, setmonitoringCycle] = useState(
    props?.editRiskManagementMonitoring?.monitoringCycle
  );
  const [pic, setpic] = useState(props?.editRiskManagementMonitoring?.pic);
  const [probabilityMonitoring, setprobabilityMonitoring] = useState(
    props?.editRiskManagementMonitoring?.probabilityMonitoring
  );
  const [impactMonitoring, setimpactMonitoring] = useState(
    props?.editRiskManagementMonitoring?.impactMonitoring
  );
  const [monitoringResult, setmonitoringResult] = useState(
    props?.editRiskManagementMonitoring?.monitoringResult
  );

  const location = useLocation();
  const [role, setRole] = useState('');

  const fetchlistByFk = async () => {
    try {
      const options = {
        url: `/risk-profile/showByFk/${routeParams.id}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      // return false;
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setlistRiskProfile([]);
      data.map((d) =>
        setlistRiskProfile((listRiskProfile) => [
          ...listRiskProfile,
          {
            label: d.rootCause,
            value: d.id,
          },
        ])
      );
    } catch (err) {
      setLoading(false);
      console.log(err.message);
    }
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchLoginStatus = async () => {
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: 'info',
          title: 'Oops, Unauthorize!',
          text: 'Session anda habis, Silahkan login kembali.',
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook('/login');
        }, 3000);
      } else {
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname == mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: 'info',
            title: 'Oops, No Access!',
            text: 'Anda tidak memiliki akses di halaman ini.',
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook('/login');
          }, 3000);
        }
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    fetchlistByFk();
    fetchLoginStatus();
    fetchOneUser();
  }, []);

  const handleEditRiskManagementMonitoring = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      idRiskProfile: idRiskProfile?.value,
      notYetHandled: notYetHandled,
      improvementIdea: improvementIdea,
      monitoringTime: monitoringTime,
      monitoringCycle: monitoringCycle,
      pic: pic,
      probabilityMonitoring: probabilityMonitoring,
      impactMonitoring: impactMonitoring,
      monitoringResult: monitoringResult,
    };
    // console.log(requestBody);
    // return false;
    axios({
      url: `/management-monitoring/update/${props?.editRiskManagementMonitoring?.id}`,
      method: 'PATCH',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res);
        // return false;
        if (res.status === 200) {
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Successfully ubah laporan!',
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== '') {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: `${err?.response?.data?.message}`,
          });
        }
      });
  };

  return (
    <div>
      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="name" className="form-label required">
              Akar Masalah Risk Profile
            </label>
            <SelectProfile
              id="name"
              value={idRiskProfile}
              onChange={setidRiskProfile}
              options={listRiskProfile}
              placeholder="Cari rencana"
            />
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="notYetHandled" className="form-label required">
              Yang Belum Tertangani
            </label>
            <input
              type="text"
              className="form-control row-cols-3"
              id="notYetHandled"
              onChange={(e) => setnotYetHandled(e.target.value)}
              value={notYetHandled}
              autoComplete="off"
            ></input>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="improvementIdea" className="form-label required">
              Usulan Perbaikan
            </label>
            <input
              type="text"
              className="form-control row-cols-3"
              id="improvementIdea"
              onChange={(e) => setimprovementIdea(e.target.value)}
              value={improvementIdea}
              autoComplete="off"
            ></input>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="monitoringTime" className="form-label required">
              Waktu Pemantauan
            </label>
            <input
              type="date"
              className="form-control row-cols-3"
              id="monitoringTime"
              onChange={(e) => setmonitoringTime(e.target.value)}
              value={monitoringTime}
            ></input>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label
              htmlFor="probabilityMonitoring"
              className="form-label required"
            >
              Probabilitas Pemantauan
            </label>
            <select
              className="form-select"
              id="probabilityMonitoring"
              onChange={(e) => setprobabilityMonitoring(e.target.value)}
              value={probabilityMonitoring}
            >
              <option selected disabled>
                Pilih
              </option>
              <option value={'Jarang'}>Jarang</option>
              <option value={'Kemungkinan Kecil'}>Kemungkinan Kecil</option>
              <option value={'Kemungkinan Sedang'}>Kemungkinan Sedang</option>
              <option value={'Kemungkinan Besar'}>Kemungkinan Besar</option>
              <option value={'Hampir Pasti Terjadi'}>
                Hampir Pasti Terjadi
              </option>
            </select>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="impactMonitoring" className="form-label required">
              Dampak Pemantauan
            </label>
            <select
              className="form-select"
              id="impactMonitoring"
              onChange={(e) => setimpactMonitoring(e.target.value)}
              value={impactMonitoring}
            >
              <option selected disabled>
                Pilih
              </option>
              <option value={'Tidak Signifikan'}>Tidak Signifikan</option>
              <option value={'Kecil'}>Kecil</option>
              <option value={'Sedang'}>Sedang</option>
              <option value={'Besar'}>Besar</option>
              <option value={'Katastropik'}>Katastropik</option>
            </select>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="monitoringCycle" className="form-label required">
              Realisasi Waktu Pemantauan
            </label>
            <select
              className="form-select"
              id="monitoringCycle"
              onChange={(e) => setmonitoringCycle(e.target.value)}
              value={monitoringCycle}
            >
              <option selected disabled>
                Pilih
              </option>
              <option value={'Setiap Hari'}>Setiap Hari</option>
              <option value={'Setiap Minggu'}>Setiap Minggu</option>
              <option value={'Setiap Bulan'}>Setiap Bulan</option>
              <option value={'Setiap Tahun'}>Setiap Tahun</option>
            </select>
          </div>
        </div>

        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="pic" className="form-label required">
              Penanggung Jawab Pemantauan
            </label>
            <input
              type="text"
              className="form-control row-cols-3"
              id="pic"
              onChange={(e) => setpic(e.target.value)}
              value={pic}
              autoComplete="off"
            ></input>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="mb-5">
            <label htmlFor="monitoringResult" className="form-label required">
              Hasil Pemantauan
            </label>
            <textarea
              className="form-control row-cols-3"
              id="monitoringResult"
              onChange={(e) => setmonitoringResult(e.target.value)}
              value={monitoringResult}
            ></textarea>
          </div>
        </div>
      </div>

      <div className="mt-5 row">
        <div className="d-flex flex-center flex-row-fluid pt-2">
          <Button
            disabled={disabled}
            variant="primary"
            size="sm"
            onClick={() => handleEditRiskManagementMonitoring()}
          >
            <IconDeviceFloppy stroke={2} />{' '}
            {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
          </Button>
          &nbsp;
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            <IconSquareX stroke={2} /> Tutup
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditRiskManagementMonitoringComp;
